// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4264) return "static/chunks/4264-4e17a99efbfb15ef.js";
	if (chunkId === 2093) return "static/chunks/2093-6289d4de317e8f9b.js";
	if (chunkId === 3648) return "static/chunks/3648-b74b13498f376552.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7646 ? "a3319169" : chunkId) + "." + {"5959":"f60695ad17bea801","7646":"5de4649371208a12","9331":"e6272afb2155b9fc"}[chunkId] + ".js";
};